import React from "react";
import { Provider, ThemeInput } from "@fluentui/react-northstar";
import { V360ReportData } from "view360Card/models";
import { ReportBox } from "../reportBox/ReportBox";
import { constants } from "shared/constants";
import { Chart, EChartTypes } from "../../../../shared/components/msTeamsUiCharts";
import { IOutlabeledChartOptions } from "shared/components/msTeamsUiCharts/components/Chart/IOutlabeledChartOptions";

export interface ProductStructureProps {
    report: V360ReportData;
    theme: ThemeInput;
    isMobileView: boolean;
}

export const ProductStructure: React.FC<ProductStructureProps> = (props) => {
    const smallPercentageValue = 10;

    const seriesNumeric = React.useMemo(
        () => props.report.seriesList.find((s) => s.unitType === constants.unitTypes.numeric),
        []
    );

    const seriesPercentage = React.useMemo(
        () => props.report.seriesList.find((s) => s.unitType === constants.unitTypes.percentage),
        []
    );

    const labels = React.useMemo(() => {
        const result: string[] = [];
        props.report.labels.forEach((label, idx) => {
            result.push(`${seriesPercentage?.dataset[idx] ?? ""}%${props.isMobileView ? "\n" : " "}${label}`);
        });
        return result;
    }, []);

    const chartData = {
        labels: labels,
        datasets: [
            {
                label: seriesNumeric?.name ?? "",
                data: seriesNumeric?.dataset ?? [],
            },
        ],
    };

    const hideSmallValues = React.useMemo(() => {
        const firstValue = seriesPercentage?.dataset[0];
        const lastValue = seriesPercentage?.dataset[seriesPercentage?.dataset.length - 1];
        if (firstValue < smallPercentageValue || lastValue < smallPercentageValue) {
            return true;
        }

        const numberOfSmallValues = seriesPercentage?.dataset.filter((n) => n < smallPercentageValue).length ?? 0;
        if (numberOfSmallValues >= 2) {
            return true;
        }
        return false;
    }, []);

    const outlabelsTextFormatting = (context: any): any => {
        const index = context.dataIndex;
        if (hideSmallValues && seriesPercentage?.dataset[index] < smallPercentageValue) {
            return "";
        }
        return context.labels[index];
    };

    const outlabeledChartOptions = (): IOutlabeledChartOptions => {
        return {
            text: outlabelsTextFormatting,
            fontMinSize: props.isMobileView ? 12 : 16,
            fontMaxSize: props.isMobileView ? 14 : 20,
            stretch: 18,
        };
    };

    const getChart = () => {
        return (
            <Provider theme={props.theme}>
                <Chart
                    title={props.report.name}
                    type={EChartTypes.Doughnut}
                    data={chartData}
                    presentsMoney
                    legendOnTheRightSide
                    hideLegend={true} //{!hideSmallValues}
                    chartContainerMinHeight={props.isMobileView ? "10rem" : undefined}
                    outlabeledChartOptions={outlabeledChartOptions()}
                />
            </Provider>
        );
    };

    return <ReportBox noGap title={props.report.name || ""} content={getChart()} />;
};
